const presetElements = [
  {
    type: 'rate',
    element: 'el-rate'
  }
]

export default presetElements
